import { useTranslation } from '@thoughtspot/i18n';
import { BannerAlert, BannerAlertType, } from '@thoughtspot/radiant-react/widgets/alert/banner/banner-alert';
import { Input } from '@thoughtspot/radiant-react/widgets/input';
import { Vertical } from '@thoughtspot/radiant-react/widgets/layout';
import { Modal, ModalSize } from '@thoughtspot/radiant-react/widgets/modal';
import { Typography } from '@thoughtspot/radiant-react/widgets/typography';
import React, { useState } from 'react';
import styles from './org-delete-modal.module.scss';
export const OrgDeleteModal = ({ isOpen, orgName, isLoading = false, onConfirm, onClose, }) => {
    const { t } = useTranslation();
    const confirmKeyword = t('adminSection.org_management.deleteModal.confirmKeyword');
    const [confirmInput, setConfirmInput] = useState('');
    const [isBannerVisible, setIsBannerVisible] = useState(true);
    return (React.createElement(Modal, { isOpen: isOpen, size: ModalSize.XSMALL, className: styles.deleteModal, title: t('adminSection.org_management.deleteModal.title'), onDismiss: onClose, confirmButton: {
            text: t('DELETE'),
            onConfirm,
            isLoading,
            isDisabled: isLoading || confirmInput !== confirmKeyword,
        }, dismissButton: {
            text: t('Cancel'),
            isDisabled: isLoading,
        }, "data-testid": "org-delete-modal" },
        React.createElement(Vertical, { hAlignContent: "stretch", grow: true, spacing: "d", "data-testid": "org-delete-content" },
            React.createElement("div", { className: styles.bannerWrapper },
                React.createElement(BannerAlert, { type: BannerAlertType.WARNING, message: t('adminSection.org_management.deleteModal.warningMessage', {
                        orgName,
                    }), isVisible: isBannerVisible, onClose: () => setIsBannerVisible(false) })),
            React.createElement(Vertical, { hAlignContent: "stretch", spacing: "b" },
                React.createElement(Typography, { variant: "p-small" }, t('adminSection.org_management.deleteModal.confirmInputLabel', { confirmKeyword })),
                React.createElement(Input.Text, { ariaLabel: confirmKeyword, value: confirmInput, placeholder: confirmKeyword, onChange: e => setConfirmInput(e.target.value.toUpperCase()), "data-testid": "org-delete-confirm-input" })))));
};
//# sourceMappingURL=org-delete-modal.js.map